import React, { useState, useEffect } from "react";
import { Dropdown, Button } from "react-bootstrap";
import { useSideBar } from "../context/SideBarContext";
import { getTruncatedText, } from '../user-pages/ui-helper';
import { ROUTES, STORAGE_KEYS } from "../../utils/key_helper";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ChangePasswordModal from "../components/modal/ChangePasswordModal";
import { useProfileContext } from "../context/ProfileContext";
import { USER_PROFILE_PATH, PORTAL_LOGO_MINI } from "../../utils/constant";
import { useTour } from "../context/TourContext";
import { getFirstLetterCapitalized } from "../../utils/helper_functions";
const Navbar = () => {
	const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
	const { toggleSideBar } = useSideBar();
	const { profileData, profileLoading } = useProfileContext();
	const [selectedImage, setSelectedImage] = useState("");
	const { startTourForPage } = useTour();
	const location = useLocation();

	const navigate = useNavigate();

	const toggleOffcanvas = () => {
		document.querySelector(".sidebar-offcanvas").classList.toggle("active");
	};
	const getCleanPathKey = (path) => {
		const segments = path.split("/").filter(Boolean);
		return segments
			.map((segment) =>
				/^\d+$/.test(segment) || /^[0-9a-fA-F\-]{4,}$/.test(segment)
					? "info"
					: segment
			)
			.join("_") || "dashboard";
	};

	const currentKey = getCleanPathKey(location.pathname);
	const handleLogout = () => {
		localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
		navigate(ROUTES.LOGIN);

	};
	useEffect(() => {
		if (profileData?.sub_user_id) {
			const imageUrl = `${USER_PROFILE_PATH}${profileData?.sub_user_id}.jpg?${new Date().getTime()}`;
			fetch(imageUrl, { method: "HEAD" })
				.then((res) => {
					if (res.ok) {
						setSelectedImage(imageUrl);
					} else {
						setSelectedImage(null);
					}
				})
				.catch(() => {
					setSelectedImage(null);
				});
		}
	}, [profileData]);

	const hiddenTourPaths = ["/dashboard", "/profile", '/configs'];
	const shouldHideTourButton = hiddenTourPaths.includes(location.pathname);
	return (
		<>
			<nav className="navbar p-0 fixed-top d-flex flex-row">
				<div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
					<div className="navbar-brand brand-logo-mini" >
						<img src={PORTAL_LOGO_MINI} alt="logo" />
					</div>
				</div>
				<div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch justify-content-end">
					<button className="navbar-toggler navbar-toggler align-self-center" type="button" style={{ border: 'none' }} onClick={() => { document.body.classList.toggle("sidebar-icon-only"); toggleSideBar(); }}	>
						<span className="mdi mdi-menu"></span>
					</button>

					<ul className="navbar-nav navbar-nav-right gap-3">
						{!shouldHideTourButton && (
							<Button variant="" className="info-button" onClick={() => startTourForPage(currentKey)}		>
								Start Tour
							</Button>
						)}

						<Dropdown align="end">
							{/* Profile button */}
							<Dropdown.Toggle as="div" className="d-flex align-items-center border-0 p-0 no-caret"    >
								<button className="profile-avtar d-flex align-items-center justify-content-center rounded-circle fw-bold text-color"  >
									{selectedImage ? (
										<img
											src={selectedImage}
											alt="Profile"
											className="sidebar-profile-img"
										/>
									) : (
										<div className="sidebar-profile-letter">
											{getFirstLetterCapitalized(profileData?.email)}
										</div>
									)}
								</button>
							</Dropdown.Toggle>
							{/* Dropdown Menu */}
							<Dropdown.Menu className="shadow-sm border-0 mt-2" style={{ maxWidth: '220px', minWidth: "220px", borderRadius: "12px", padding: "8px 0", }}   >
								{/* User info header */}
								<div className="px-3 py-2  ">
									{getTruncatedText(profileData?.email, 20, 'd-block  small', 'strong')}
								</div>
								<Dropdown.Divider className="my-1" />
								<Dropdown.Item className="d-flex align-items-center py-2" onClick={() => setShowChangePasswordModal(true)}   >
									<i className="mdi mdi-key me-2 warning-text" />
									Change Password
								</Dropdown.Item>
								<Dropdown.Divider className="my-1" />
								<Dropdown.Item className="d-flex align-items-center py-2 " onClick={handleLogout}     >
									<i className="mdi mdi-logout me-2 danger-text" />
									Log Out
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</ul>
					<button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={toggleOffcanvas}	>
						<span className="mdi mdi-format-line-spacing"></span>
					</button>
				</div>
				{showChangePasswordModal && (
					<ChangePasswordModal
						show={showChangePasswordModal}
						onClose={() => setShowChangePasswordModal(false)}
					/>
				)}
			</nav>
		</>
	);
};

export default Navbar;